module.exports = __webpack_public_path__ + "img/ai_round_logo.8f25e241.png";